<div class="max-h-96 overflow-auto">
  <table
    class="min-w-full w-max table-fixed border-separate border-spacing-0 text-sm text-left rtl:text-right text-gray-500"
  >
    <thead class="text-xs uppercase bg-amazone-orange text-gray-100 sticky top-0 z-10">
      <tr>
        <!--A, B, C etc.-->
        <th scope="col" class="w-32 align-top px-4 py-3">Release</th>
        @for (col of currentStepFields; track $index) {
          <th scope="col" class="max-w-72 align-top px-4 py-3">
            <label class="flex min-w-0 items-start gap-2">
              <input
                (change)="onCheckboxChangeForColumn($event, col)"
                type="checkbox"
                [checked]="isColumnChecked(col)"
                class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:border-gray-200"
              />
              <span class="whitespace-normal break-words">{{ col }}</span>
            </label>
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @if (!propertyUpdateInfo?.anyFieldsAffected) {
        <tr>
          <td
            class="px-6 py-4 text-center font-medium text-amazone-orange align-top"
            [attr.colspan]="(currentStepFields.length || 0) + 1"
          >
            No changes in other versions
          </td>
        </tr>
      }
      @for (info of propertyUpdateInfo?.entityPropertyUpdateSynchronisationInfosForCurrentStep; track $index) {
        <tr class="bg-white border-b hover:bg-gray-50">
          <td class="px-4 py-4 align-top font-semibold text-gray-700">
            {{ info.swPartNumber }}
          </td>
          @for (col of currentStepFields; track $index) {
            <td class="w-64 min-w-48 max-w-72 px-4 py-4 align-top">
              <label
                [ngClass]="info.isEditedEntity ? 'opacity-60' : ''"
                class="flex min-w-0 items-start gap-2 text-xs text-gray-700"
              >
                <input
                  (change)="
                    onCheckboxChange(
                      $event,
                      info.entityId,
                      $safeNavigationMigration(info?.getPropertyByName(col)?.propertyName)
                    )
                  "
                  type="checkbox"
                  [checked]="info?.isEditedEntity || info?.getPropertyByName(col)?.updatedValueIsConfirmed"
                  [disabled]="info.isEditedEntity"
                  class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:border-gray-200"
                />
                <app-diff-field-viewer
                  class="block min-w-0 flex-1"
                  [diffField]="$safeNavigationMigration(info?.getPropertyUpdateDiffField(col))"
                ></app-diff-field-viewer>
              </label>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
